module.exports = __webpack_public_path__ + "media/images/dummy_item10-c52bddec22886f6047d55b4b57d817f7.jpg";